module.exports = __webpack_public_path__ + "assets/924e8a59afe7785db352cd5b5574a061.mp3";